// packages
import { entries } from 'd3-collection';
import { intcomma } from 'journalize';
import { h } from 'preact';

// components
import CandidateRow from './CandidateRow';
import PureComponent from './PureComponent';

// internal
import formatPercent from '../utils/format-percent';
import { sort_candidates_by_party } from '../election-utils';
import { source } from '../endpoints';
import sumValues from '../utils/sum-values';

class TooltipTable extends PureComponent<any> {
  render() {
    const { candidatesMap, county } = this.props;

    const sortedResults = entries(county.results).sort(
      (a, b) => b.value - a.value
    );

    const totalVotes = sumValues(sortedResults, 'value');



    let sorted_by_party;

    const firstFourResults = sortedResults.slice(0, 4);

    const pct_votes = formatPercent(
      county.total_votes,
      county.estimated_votes_high
    )

    const pct_votes_turnout = pct_votes < 100 ? `An estimated ${pct_votes}% votes counted` : `An estimated >99% votes counted`


    return (
      <div class="contest">
        <table class="contest__candidates contest__candidates--tooltip">
          <caption>
            <p class="contest__title">{county.county} County</p>
            <div class="contest__metrics">
              <p class="contest__precincts">
                {source != 'Decision Desk HQ'
                  ? `${formatPercent(
                      county.county_pollinglocationsreporting,
                      county.total_county_pollinglocations
                    )}% reporting`
                  : pct_votes_turnout}
              </p>
            </div>
          </caption>
          {CandidateRow.countyHeader}
          <tbody>
            {firstFourResults.map(result => {
              const candidate = candidatesMap.get(result.key);
              // Just show last names to the county tooltip
              const last_names = candidate.name

                .split(' ')
                .pop()
                .trim();

              return (
                <CandidateRow
                  key={candidate.id}
                  ballotName={last_names}
                  candidateId={candidate.id}
                  contestIsCalled={false}
                  isIncumbent={candidate.is_incumbent}
                  party={candidate.party}
                  totalVotesInContest={county.total_votes}
                  votes={result.value}
                />
              );
            })}
          </tbody>
        </table>
      </div>
    );
  }
}

export default TooltipTable;
